export default [
	{
	    path: "zyba/list",
	    name: "ZybaList",
	    component: () => import('./ZybaList.vue')
	}
];






